import { Form, Formik, useFormik } from "formik";
import React, { useState, useEffect } from "react";
import * as Yup from "yup";
// import { historyDocuments as documents } from './documents';
import { ParagraphComp } from "../../../Components/ParagraphComp/ParagraphComp";
import CustomInput from "../../../Components/InputCompo/CustomInput";
import ButtonComp from "../../../Components/ButtonComp/ButtonComp";
import CustomTextarea from "../../../Components/textareaComp/CustomTextarea";
import {
  HistoryGet,
  HistoryPost,
  editRegistration,
} from "../../../Store/auth/register";
import { useMutation, useQuery } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import Loading from "../../../Components/Loader/Loading";
import CloseIcon from "@mui/icons-material/Close";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddCommentIcon from "@mui/icons-material/AddComment";
import ModalComp from "../../../Components/ModalComp";
import HeaderCompo from "../../../Components/HeaderComp/HeaderCompo";
import CustomSelection from "../../../Components/SelectionComp/CustomSelection";
import MultipleSelect from "../../../Components/SelectionComp/MultipleSelect";
import CustomFileInput from "../../../Components/InputCompo/CustomFileInput";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

const History = ({ setSubTabs }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const application_no = localStorage.getItem("RegKey");

  const getGsnNo = localStorage.getItem("gsn_no");
  const { isLoading: fieldLoading, data: questions } = useQuery({
    queryKey: "history",
    queryFn: () => HistoryGet(getGsnNo ? getGsnNo : ""),
  });

  const modelSchema = Yup.object().shape({
    ...questions?.documents?.reduce((schema, fields) => {
      if (fields.type.toLowerCase() !== "section") {
        // Define validation rules
        let fieldValidation = Yup.string();
        if (
          fields?.depend_question &&
          (fields.type.toLowerCase() === "password" ||
            fields.validation.toLowerCase() === "email")
        ) {
          fieldValidation = fieldValidation.test(
            "match-dependent",
            `${fields.question} must match the related field`,
            function (value) {
              const { parent } = this;
              const dependentValue = parent[fields.depend_question];

              if (fields.type.toLowerCase() === "password") {
                return value === dependentValue;
              } else if (fields.validation.toLowerCase() === "email") {
                return value === dependentValue;
              }

              return true;
            }
          );
        }
        // Apply different validation rules based on the field's validation type
        if (
          fields.validation.toLowerCase() === "email" &&
          !fields?.depend_question
        ) {
          fieldValidation = fieldValidation.matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            "Invalid email address"
          );
        } else if (fields.validation.toLowerCase() === "pan") {
          fieldValidation = fieldValidation.matches(
            /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
            "Invalid PAN Number. It should be in the format: ABCDE1234F."
          );
        } else if (fields.validation.toLowerCase() === "pincode") {
          fieldValidation = Yup.string().matches(
            /^\d{4}$|^\d{6}$/,
            "PIN code must be exactly 6 digits"
          );
        } else if (fields.validation.toLowerCase() === "areacode") {
          fieldValidation = fieldValidation.matches(
            /^(123|456|789)$/,
            "Incorrect area code"
          );
        } else if (fields.type.toLowerCase() === "multiselect dropdown") {
          fieldValidation = Yup.array();
        } else if (fields.validation.toLowerCase() === "website") {
          fieldValidation = fieldValidation.url("Please enter a valid URL");
        } else if (fields.validation.toLowerCase() === "mobile") {
          fieldValidation = fieldValidation.matches(
            /^(?:[0-9]{10}|[0-9]{7})$/,
            "Invalid contact number"
          );
        } else if (fields.type.toLowerCase() === "attach") {
          fieldValidation = Yup.object();
        } else if (fields.validation.toLowerCase() === "darpan") {
          fieldValidation = fieldValidation.test(
            "is-valid-darpan",
            "Invalid PAN Darpan Id. It should be in the format: XX/1234/1234567.",
            (value) => {
              if (value?.toUpperCase() === "NA") {
                return true;
              }
              return /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value);
            }
          );
        } else if (
          fields.validation.toLowerCase() === "password" &&
          !fields?.depend_question
        ) {
          fieldValidation = fieldValidation.min(
            8,
            "Password must be at least 8 characters long"
          );
        }

        // Apply required validation if the field is mandatory
        if (fields.mandatory === 1) {
          fieldValidation = fieldValidation.required(
            `${fields.question} is required`
          );
        }

        // Assign the validation rule to the field in the schema
        schema[fields?.question_no] = fieldValidation;
      }

      return schema;
    }, {}),
  });
  const createInitialValues = () => {
    if (questions?.docs_answers?.length > 0) {
      return questions.docs_answers.reduce((values, field) => {
        if (field.type.toLowerCase() === "section") {
          // Initialize section with template name as an array of objects
          if (field?.answer?.length > 0) {
            const tempData = [];
            field.answer.forEach((Row, index) => {
              Row.forEach((Field) => {
                if (!tempData[index]) tempData[index] = {}; // Ensure initialization

                if (Field.type.toLowerCase() === "multiselect dropdown") {
                  tempData[index][Field?.question_no] =
                    Field?.answer?.split(",") || [];
                } else if (Field?.type.toLowerCase() === "attach") {
                  tempData[index][Field?.question_no] = {
                    file_name: Field?.upload_document,
                  };
                } else {
                  tempData[index][Field?.question_no] = Field?.answer || ""; // Ensure default empty value
                }
              });
            });
            values[field.template] = values[field.template] || tempData; // Ensure array initialization
          } else {
            values[field.template] = values[field.template] || [{}]; // Ensure array initialization
            values[field.template].forEach((row) => {
              field?.sub_questions?.forEach((subField) => {
                row[subField?.question_no] =
                  subField?.question === "Country Code" ? "+91 - India" : "";
              });
            });
          }
        } else {
          // Normal fields, assign to `normalFields`
          values.normalFields = values.normalFields || {};
          if (field?.question_no) {
            if (field.type.toLowerCase() === "multiselect dropdown") {
              values.normalFields[field.question_no] =
                field?.answer?.split(",") || [];
            } else if (field?.type.toLowerCase() === "attach") {
              values.normalFields[field.question_no] = {
                file_name: field?.upload_document,
              };
            } else {
              values.normalFields[field.question_no] = field?.answer || ""; // Ensure default empty value
            }
          }
        }
        return values;
      }, {});
    } else {
      return questions?.documents?.reduce((values, field) => {
        values.normalFields = values.normalFields || {};
        values.normalFields[field?.question_no] = "";

        if (field.type.toLowerCase() === "section") {
          if (field?.answer?.length > 0) {
            const tempData = [];
            field.answer.forEach((Row, index) => {
              Row.forEach((Field) => {
                if (!tempData[index]) tempData[index] = {}; // Ensure initialization

                tempData[index][Field?.question_no] = Field?.answer || ""; // Ensure default empty value
              });
            });
            values[field.template] = values[field.template] || tempData; // Ensure array initialization
          } else {
            values[field.template] = values[field.template] || [{}]; // Ensure array initialization
            values[field.template].forEach((row) => {
              field?.sub_questions?.forEach((subField) => {
                row[subField?.question_no] =
                  subField?.question === "Country Code" ? "+91 - India" : "";
              });
            });
          }
        }
        return values;
      }, {});
    }
  };
  const formik = useFormik({
    initialValues: createInitialValues(),
    validationSchema: modelSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const tempData = questions?.documents?.map((fields) => {
          // Access values using the updated structure
          const fieldValue = values.normalFields[fields.question_no]; // Updated access

          if (fields?.type.toLowerCase() === "attach" && fieldValue) {
            return {
              question_no: fields?.question_no,
              attach_file: fieldValue?.file64,
              file_name: fieldValue?.fileName,
            };
          } else if (fields?.type.toLowerCase() === "number") {
            return {
              question_no: fields?.question_no,
              answer: `${fieldValue}`, // Updated access
            };
          } else if (fields?.type.toLowerCase() === "checkbox") {
            return {
              question_no: fields?.question_no,
              answer: `${fieldValue ? "Y" : "N"}`, // Updated access
            };
          } else if (
            fields?.type.toLowerCase() === "multiselect dropdown" &&
            fieldValue
          ) {
            return {
              question_no: fields?.question_no,
              answer: `${fieldValue.map((ele) => ele).join(",")}`, // Updated access
            };
          } else {
            return {
              question_no: fields?.question_no,
              answer: fieldValue, // Updated access
            };
          }
        });

        const structuredData = {
          args: {
            name: getGsnNo,
            section_last_updated_on: "2024-09-04",
            history_question_answers: tempData,
          },
        };
        //
        await historyReg(structuredData);
      } catch (error) {
        console.error(error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleCreateSuccess = () => {
    enqueueSnackbar("success!", { variant: "success" });
    setSubTabs({ "Target Segment": true });
  };

  const handleCreateError = (error) => {
    if (error?.response?.data.status_code >= 500) {
      enqueueSnackbar(error?.response?.data?.status_message, {
        variant: "error",
      });
    } else {
      enqueueSnackbar(error?.response?.data?.message || error?.message, {
        variant: "error",
      });
    }
  };

  const createFarmerMutationOptions = {
    onSuccess: handleCreateSuccess,
    onError: handleCreateError,
  };

  const {
    mutate: historyReg,
    // data: regFinalData,
    isPending: mainRegistration,
  } = useMutation({
    mutationFn: HistoryPost,
    ...createFarmerMutationOptions,
  });

  const editModalSchema = Yup.object().shape({
    [isModalOpen?.data?.question_no]: (() => {
      let validation = Yup.string();

      // Check if isModalOpen?.data is defined
      if (!isModalOpen?.data) return validation;

      const fieldType = isModalOpen.data.type?.toLowerCase();
      const fieldValidation = isModalOpen.data.validation?.toLowerCase();

      // Apply validation based on `validation` property
      if (fieldValidation === "email" && !isModalOpen.data?.depend_question) {
        validation = validation.matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Invalid email address"
        );
      } else if (fieldValidation === "pan") {
        validation = validation.matches(
          /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
          "Invalid PAN Number. Format: ABCDE1234F."
        );
      } else if (fieldValidation === "pincode") {
        validation = validation.matches(
          /^\d{4}$|^\d{6}$/,
          "PIN code must be exactly 4 or 6 digits"
        );
      } else if (fieldValidation === "mobile") {
        validation = validation.matches(
          /^(?:[0-9]{10}|[0-9]{7})$/,
          "Invalid contact number"
        );
      } else if (fieldValidation === "website") {
        validation = validation.url("Please enter a valid URL");
      } else if (fieldValidation === "darpan") {
        validation = validation.test(
          "is-valid-darpan",
          "Darpan ID should be in the format: XX/1234/1234567",
          (value) =>
            value?.toUpperCase() === "NA" ||
            /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
        );
      } else if (
        fieldValidation === "password" &&
        !isModalOpen.data?.depend_question
      ) {
        validation = validation.min(
          8,
          "Password must be at least 8 characters long"
        );
      } else if (fieldType === "multiselect dropdown") {
        validation = Yup.array().of(Yup.string());
      } else if (fieldType === "attach") {
        validation = Yup.object();
      }

      // Apply 'required' validation if `mandatory` is 1
      if (isModalOpen.data.mandatory === 1) {
        validation = validation.required(
          `${isModalOpen.data.question} is required`
        );
      }

      return validation;
    })(),
  });

  const attachFile = (e, setFieldValue) => {
    if (!e.target.files || e.target.files.length === 0) {
      setFieldValue(e.target.name, "");
      return; // Prevent further execution if no file is selected
    }
    const file = e.target.files[0];
    const name = e.target.name;
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setFieldValue(name, {
          attach_file: base64String,
          file_name: file.name,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  // waiting for fields

  const commonEditOpenModal = (
    name,
    data,
    values,
    type,
    template,
    sub_question_num,
    subQuestion
  ) => {
    setIsModalOpen({
      [name]: true,
      data,
      values,
      type: type,
      template: template,
      sub_question_num: sub_question_num,
      subQuestion,
    });
  };

  const commonEditCloseModal = () => {
    if (!editLoading) {
      setIsModalOpen("");
    }
  };

  console.log(
    "docs>>>",
    questions?.documents?.find((doc) => doc?.type?.toLowerCase() === "section")
      ?.template
  );

  const hasAnswerForQuestion = (Fields, subQ) => {
    // Check if there are any answers in docs_answers
    const hasAnyAnswer =
      questions?.docs_answers?.length > 0 &&
      questions?.docs_answers?.some(doc => doc?.answer)

    // Find the specific document matching Fields.template
    const doc = questions?.docs_answers?.find(doc => doc?.template === Fields?.template);

    // Check if there's at least one non-empty answer for the specific document
    const isAnyAnswerFilled = doc?.answer?.length > 0 && doc?.answer?.some(ele => ele.some(dt => dt?.answer)) || false;

    return isAnyAnswerFilled || hasAnyAnswer;
  };
  const updateValues = async (values) => {
    try {
      console.log("isModalOpen>>>>", isModalOpen)
      const currentDate = await new Date()
      let structuredData = ''
      if (isModalOpen?.type?.toLowerCase() === 'section') {
        const PreviousData = questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index].find(ans => ans.question_no === isModalOpen?.data.question_no)
        structuredData = await
          {
            args: {
              gsn_number: getGsnNo,
              date_and_time: formatDateTime(currentDate),
              gsi_id: application_no,
              question_id: isModalOpen?.sub_question_num,
              subquestion_id: PreviousData?.question_no,
              subquestion_previous_answer: PreviousData?.answer,
              subquestion_edited_answer: isModalOpen?.data?.type?.toLowerCase() === "multiselect dropdown" ?
                `${values?.[isModalOpen?.data?.question_no].map(ele => { return ele })}` : values?.[PreviousData?.question_no],
              subquestion_text: PreviousData?.question,
              question_text: isModalOpen?.subQuestion,
              section_name: 'History'
            }
          }


      } else {
        structuredData = await
          {
            args: {
              gsn_number: getGsnNo,
              date_and_time: formatDateTime(currentDate),
              gsi_id: application_no,
              question_id: isModalOpen?.data?.question_no,
              question_text: isModalOpen?.data?.question,
              previous_answer:
                values?.normalFields?.[isModalOpen?.data?.question_no] ||
                (questions?.docs_answers?.length > 0 &&
                  questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer) || '',
              edited_answer:
                isModalOpen?.data?.type?.toLowerCase() === "multiselect dropdown" ?
                  `${values?.[isModalOpen?.data?.question_no].map(ele => { return ele })}`
                  :
                  values?.[isModalOpen?.data?.question_no],
              section_name: 'History'
            }
          }
      }
      console.log("structuredData>>>>", structuredData)

      await editData(structuredData)

    } catch (error) {

    }
  };
  const formatDateTime = (isoString) => {
    const date = new Date(isoString);

    // Extract YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits

    // Extract HH:MM:SS in 24-hour format
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  const { mutate: editData, isPending: editLoading } = useMutation({
    mutationFn: editRegistration,
    ...createFarmerMutationOptions,
    onMutate: async () => {
      // Cancel the current query before mutating
      // await queryClient.cancelQueries(['Questions', application_no]);
    },
    onSuccess: () => {
      // Invalidate the query to refetch the latest data
      // queryClient.invalidateQueries(['Questions', application_no]);
    },
  });

  const modalMultiSelectedValues = (name, values, setModalFieldValue) => {
    setModalFieldValue(name, values);
  };

  useEffect(() => {
    if (!editLoading) {
      setIsModalOpen("");
    }
  }, [editLoading]);

  if (fieldLoading || mainRegistration) return <Loading />;

  return (
    <>
      <form className='flex flex-col gap-[10px]' onSubmit={formik.handleSubmit}>




        {/* Second Section: Display text or textarea fields */}
        <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
          {questions?.documents.slice(0, 4).map(Fields => (
            <>
              <div>
                <ParagraphComp className=' text-2xl' text={Fields.paremeter} />
              </div>
              <div key={Fields.question_no} className='w-[100%]'>
                {Fields.type.toLowerCase() === 'text' && (
                  <div className='flex gap-[10px]'>
                    <CustomInput
                      // disabled={questions?.docs_answers?.length > 0 && questions?.docs_answers?.some(doc => doc?.answer)}
                      required={Fields?.mandatory > 0}
                      {...formik.getFieldProps(`normalFields.${Fields.question_no}`)}
                      name={`normalFields.${Fields.question_no}`}
                      label={Fields.question}
                      onBlur={formik.handleBlur}
                    />
                    {/* {questions?.docs_answers?.length > 0 && questions?.docs_answers?.some(doc => doc?.answer) &&

                      <div className="flex gap-[10px] mt-[8px]">
                        <div onClick={() => commonEditOpenModal('edit', Fields, formik?.values)} className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]">
                          <BorderColorIcon className="text-white" />
                        </div>
                        <div onClick={() => commonEditOpenModal('comment', formik?.values)} className="bg-[#004878] relative h-fit rounded-full p-[8px]">
                          {
                            (questions?.docs_answers?.length > 0 &&
                              questions?.docs_answers?.find(doc => doc?.question_no === Fields?.question_no)?.comments_for_npo)
                            &&
                            <div className="absolute z-10 bg-[red] mt-[-15px] ml-[17px] rounded-full p-[1px] ">
                              <NotificationsActiveIcon className=" text-[#ffffff]" />
                            </div>
                          }
                          <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                        </div>
                      </div>
                    } */}
                  </div>
                )}
                {Fields.type.toLowerCase() === 'text area' && (
                  <div className='flex gap-[10px]'>
                    <CustomTextarea
                      // disabled={questions?.docs_answers?.length > 0 && questions?.docs_answers?.some(doc => doc?.answer)}

                      required={Fields?.mandatory > 0}
                      {...formik.getFieldProps(`normalFields.${Fields.question_no}`)}
                      name={`normalFields.${Fields.question_no}`}
                      label={Fields.question}
                      onBlur={formik.handleBlur}
                    />
                    {/* {questions?.docs_answers?.length > 0 && questions?.docs_answers?.some(doc => doc?.answer) &&

                      <div className="flex gap-[10px] mt-[8px]">
                        <div onClick={() => commonEditOpenModal('edit', Fields, formik?.values)} className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]">
                          <BorderColorIcon className="text-white" />
                        </div>
                        <div onClick={() => commonEditOpenModal('comment', formik?.values)} className="bg-[#004878] relative h-fit rounded-full p-[8px]">
                          {
                            (questions?.docs_answers?.length > 0 &&
                              questions?.docs_answers?.find(doc => doc?.question_no === Fields?.question_no)?.comments_for_npo)
                            &&
                            <div className="absolute z-10 bg-[red] mt-[-15px] ml-[17px] rounded-full p-[1px] ">
                              <NotificationsActiveIcon className=" text-[#ffffff]" />
                            </div>
                          }
                          <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                        </div>
                      </div>
                    } */}
                  </div>
                )}
                <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.touched[Fields.question_no] && formik.errors[Fields.question_no]} />
                <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px] h-auto' text={Fields.description} />
              </div>
            </>
          ))}
        </div>

        {/* Buttons */}
        {/* {
          questions?.docs_answers?.length > 0 && questions?.docs_answers?.some(doc => doc?.answer) ?
            '' : */}

            <div className='flex justify-end'>
              <div className='flex gap-[20px]'>
                <ButtonComp text='Save' className='px-[20px] rounded-full border-1 border-[#004878] text-[#004878] py-[10px]' />
                <ButtonComp text='Save & Next' className='px-[20px] rounded-full bg-[#004878] text-[white] py-[10px]' />
              </div>
            </div>
        {/* } */}
      </form>
      <ModalComp width={'35%'} modalIsOpen={isModalOpen?.['comment']} closeModal={commonEditCloseModal} >
        <HeaderCompo className='text-2xl mb-[10px] font-bold text-black mt-[10px] text-center' tagType={'h3'} text='Comment' />
        <ParagraphComp className='text-lg text-black text-center' >
          {console.log("modal<<<",)}
          {isModalOpen?.type?.toLowerCase() === 'section' ?
            ((questions?.docs_answers?.length > 0 &&
              Array.isArray(questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer)) &&
              questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator' :
            (questions?.docs_answers?.length > 0 &&
              questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator.'}
        </ParagraphComp>
        <div className="flex justify-end">
          <ButtonComp onClick={commonEditCloseModal} type='button' className=' mt-[10px] py-[5px] px-[10px] rounded-[20px] border-2 border-[#004878] text-[#004878]'>
            Close
          </ButtonComp>
        </div>

      </ModalComp>
      <ModalComp width={'35%'} modalIsOpen={isModalOpen?.['edit']} closeModal={commonEditCloseModal} >
        {console.log("isModalOpen>>>>>", isModalOpen)}
        <Formik
          enableReinitialize
          initialValues={{
            [isModalOpen?.data?.question_no || 'default_question_no']:
              isModalOpen?.type?.toLowerCase() === 'section' ?
                formik?.values?.[isModalOpen?.template][isModalOpen?.index]?.[isModalOpen?.data?.question_no] ||
                (questions?.docs_answers?.length > 0 &&
                  questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.find(ele => ele.question_no === isModalOpen?.data.question_no)) || '' :
                isModalOpen?.data?.type === 'Attach' && questions?.docs_answers?.length > 0
                  ? { file_name: questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.upload_document || '' }
                  : isModalOpen?.data?.type === 'Multiselect Dropdown' && questions?.docs_answers?.length > 0
                    ? questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer?.split(',')
                    : formik?.values?.[isModalOpen?.data?.question_no] ||
                    (questions?.docs_answers?.length > 0 &&
                      questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer) || '',
          }}
          validationSchema={editModalSchema}
          onSubmit={(values) => {
            updateValues(values);
          }}
        >


          {({ values: modalValues, errors: modalErrors, handleChange, setFieldValue: setModalFieldValue }) => (

            <Form action="">
              {console.log("modalErrors>>>>", modalErrors)}
              <div className='h-auto'>
                <div className='flex justify-end'>
                  <div className='cursor-pointer' onClick={commonEditCloseModal}>
                    <CloseIcon />
                  </div>
                </div>
                <HeaderCompo className='text-2xl mb-[10px] font-bold text-black mt-[10px] text-center' tagType={'h3'} text='Edit' />
                <ParagraphComp className='text-lg text-black text-start' text='Question' />
                <ParagraphComp className='text-md mt-[10px] text-[#3f3f3f] text-start' text={isModalOpen?.data?.question} />
                {isModalOpen?.type?.toLowerCase() === 'section' ?
                  formik?.values?.[isModalOpen?.template][isModalOpen?.index]?.[isModalOpen?.data?.question_no] ||
                  (questions?.docs_answers?.length > 0 &&
                    questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.find(ele => ele.question_no === isModalOpen?.data.question_no)) || '' :
                  formik?.values?.normalFields?.[isModalOpen?.data?.question_no] ||
                    (questions?.docs_answers?.length > 0 &&
                      questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer)
                    ?
                    <ParagraphComp className='text-lg mt-[10px] text-black text-start' text='Current Answer' />
                    : ''
                }
                {isModalOpen?.data?.type.toLowerCase() === 'text' || isModalOpen?.data?.type.toLowerCase() === 'number' || isModalOpen?.data?.type.toLowerCase() === 'date' || isModalOpen?.data?.type.toLowerCase() === 'password' ?
                  < div className='mt-[20px]'>
                    <CustomInput required={true}
                      type={isModalOpen?.data?.type?.toLowerCase()}
                      name={isModalOpen?.data?.question_no}
                      value={modalValues?.[isModalOpen?.data?.question_no]}
                      onChange={handleChange} label='New Answer' />
                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                  </div>
                  :
                  isModalOpen?.data?.type?.toLowerCase() === 'text area' ?
                    < div className='mt-[20px]'>
                      <CustomTextarea
                        required={true}
                        name={isModalOpen?.data?.question_no}
                        value={modalValues?.[isModalOpen?.data?.question_no]}
                        onChange={handleChange}
                        label='New Answer' />
                      <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                    </div>
                    :
                    isModalOpen?.data?.type.toLowerCase() === 'dropdown' ?
                      < div className='mt-[20px]'>
                        <CustomSelection
                          imgKey='flag'
                          exDataKey={isModalOpen?.data?.question === 'Country Code' ? 'label' : undefined}
                          mappingKey={isModalOpen?.data?.question === 'Country Code' ? 'phone' : undefined}
                          options={isModalOpen?.data?.options}
                          required={true}
                          value={modalValues?.[isModalOpen?.data.question_no]}
                          onChange={handleChange}
                          name={isModalOpen?.data.question_no}
                          label='New Answer'
                        />
                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                      </div>
                      : isModalOpen?.data?.type.toLowerCase() === 'multiselect dropdown' ?
                        < div className='mt-[20px]'>
                          <MultipleSelect
                            required={true}
                            options={isModalOpen?.data?.options
                            }
                            maxSelect={isModalOpen?.data.validation === 'Select Upto 3' && 3}
                            mappingKey={isModalOpen?.data?.question_no !== "DRQ-00077" ? "option" : 'option'} // Pass mapping key if needed
                            onValueChange={(name, values) => modalMultiSelectedValues(name, values, setModalFieldValue)}
                            selectedValues={modalValues?.[isModalOpen?.data?.question_no] || []}
                            name={isModalOpen?.data?.question_no}
                            label='New Answer'
                          />
                          <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />

                        </div>
                        :
                        isModalOpen?.data?.type.toLowerCase() === 'attach' ?
                          <div className='mt-[20px]'>
                            <CustomFileInput
                              required={true}
                              onChange={(e) => attachFile(e, setModalFieldValue)}
                              value={modalValues?.[isModalOpen?.data?.question_no].file_name}
                              name={isModalOpen?.data?.question_no}
                              label="New Answer"
                            />
                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                          </div>
                          : ''

                }

                <div className="flex justify-center mt-[15px]">
                  <ButtonComp
                    disabled={editLoading ? true : false}
                    className="w-[150px] rounded-full bg-[#004878] p-[6px] text-white border-none"
                    type="Submit"
                    text={editLoading ? "Saving..." : "Save"}
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </ModalComp>
    </>
  );
};

export default History;
